import { pr, React, theme, ui } from "aaa";
import { themeColors } from "muiTheme";

export const JuniorPillBadge: React.FC<{
    children: React.ReactNode;
    style?: React.CSSProperties;
}> = ({ children, style }) => (
    <pr.P_14_CONTENT
        style={{
            display: "inline-block",
            flexShrink: 0,
            margin: 0,
            padding: "5px 14px",
            borderRadius: theme.BORDER_RADIUS_FULL,
            fontWeight: 600,
            lineHeight: "18px",
            backgroundColor: ui.isDarkMode
                ? "rgba(57, 139, 252, 0.22)"
                : themeColors.ui_blue_light,
            color: ui.isDarkMode ? theme.themeColors.d_blue_100 : themeColors.blue_300,
            ...style,
        }}
    >
        {children}
    </pr.P_14_CONTENT>
);



// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/JuniorPillBadge.tsx